module.exports = __webpack_public_path__ + "img/step3-no.831efb58.png";